import NavBar from "../../../components/navbar";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import BaseListPage from "../../../base/BaseListPage";
import productivityReportPresenter from "./ProductivityReportPresenter";
import { exportCSVUseCase } from "../../../usecases/csv/usecases";
import {
  addSchemaUseCase,
  deleteSchemaUseCase,
  updateSchemaUseCase,
} from "../../../usecases/schema/usecases";
import DateRange from "./components/DateRange";
import ReportTable from "./components/ReportTable";
import { InfiniteScroll, Progress } from "../../../nq-component";
import TableHeader from "./components/TableHeader";

class ProductivityReportPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new productivityReportPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase(),
      getObjectUseCase(),
      addSchemaUseCase(),
      updateSchemaUseCase(),
      deleteSchemaUseCase()
    );
    this.state = {
      reports: [],
      progress: true,
      animationComplete: false,
      currentDate: new Date().toISOString(),
      startDate: null,
      endDate: null,
    };
  }

  componentDidMount() {
    this.getReports();
    setTimeout(() => {
      this.setState({ animationComplete: true });
    }, 300);
  }

  async getReports() {
    await this.presenter.calculateReports();
  }

  downloadCSV() {
    const { reports, currentDate, startDate, endDate } = this.state;

    const dateStart =
      startDate && endDate ? new Date(startDate).toISOString() : currentDate;

    let dateEnd = null;
    if (endDate) {
      dateEnd = new Date(endDate).toDateString();
    }

    this.presenter.downloadCSV(reports, dateStart, dateEnd);
  }

  onChangeDate(value) {
    const date = value;
    const updatedDate = new Date(date);
    const changeDate = new Date(
      updatedDate.getFullYear(),
      updatedDate.getMonth(),
      updatedDate.getDate()
    );
    const isoDate = changeDate.toISOString();
    this.setState({ currentDate: isoDate }, () => {
      this.getReports();
    });
  }

  onChangeDate(value, field) {
    this.setState({ [field]: value }, () => {
      this.getReports();
    });
  }

  render() {
    const { reports, progress, animationComplete } = this.state;

    const user = this.getCurrentUser();

    return (
      <>
        <NavBar user={user} />
        <div className="overflow-auto">
          <InfiniteScroll>
            <div className="p-4">
              <div
                className={`card shadow-sm ${
                  animationComplete ? "opacity-100" : "opacity-0"
                }`}
                style={{
                  transition: "all 0.5s ease-in-out",
                  transform: animationComplete
                    ? "translateY(0)"
                    : "translateY(20px)",
                }}
              >
                <TableHeader
                  animation={animationComplete}
                  onDownload={this.downloadCSV.bind(this)}
                />

                <div className="card-body">
                  <div
                    className="row mb-4"
                    style={{
                      transition: `all 0.5s ease-in-out 0.2s`,
                      transform: animationComplete
                        ? "translateY(0)"
                        : "translateY(10px)",
                      opacity: animationComplete ? 1 : 0,
                    }}
                  >
                    <DateRange onChange={this.onChangeDate.bind(this)} />
                  </div>
                  {progress ? <Progress /> : <ReportTable objects={reports} />}
                </div>
              </div>
            </div>
          </InfiniteScroll>
        </div>

        <style jsx>{`
          .card {
            border: none;
            border-radius: 8px;
          }
          .card-header {
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
            border-radius: 8px 8px 0 0 !important;
          }
          .table th {
            font-weight: 600;
            border-top: none;
            text-align: center;
            font-size: 0.9rem;
            vertical-align: middle;
          }
          .table td {
            vertical-align: middle;
          }
          .btn-success:hover {
            background-color: #b06b27 !important;
            border-color: #b06b27 !important;
          }
        `}</style>
      </>
    );
  }
}

export default ProductivityReportPage;
